import { useEffect, useState } from 'react';

const META_PIXEL_ID = '4658568881066261';
const CONSENT_KEY = 'kindstone_meta_pixel_consent';

const readConsent = () => {
  try {
    return window.localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

// Meta's tracking script is intentionally not loaded before a visitor opts in.
// There is no no-script tracking image, so declining consent sends no PageView.
const startMetaPixel = () => {
  if (typeof window === 'undefined' || readConsent() !== 'accepted' || window.fbq) return;

  // Meta's standard pixel bootstrap, loaded only after affirmative consent.
  !function(f,b,e,v,n,t,s) {
    if (f.fbq) return;
    n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;
    n.push=n;
    n.loaded=!0;
    n.version='2.0';
    n.queue=[];
    t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s);
  }(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');

  // Avoid Meta's automatic extraction of form values. Also turn off
  // Automatic Advanced Matching in Events Manager before launch.
  window.fbq('set', 'autoConfig', false, META_PIXEL_ID);
  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
};

export const trackKindstoneLead = () => {
  // Never attach field values, emails, phone numbers, ZIPs, or custom data.
  if (typeof window === 'undefined' || readConsent() !== 'accepted') return;
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'Lead');
  }
};

const MetaPixelConsent = () => {
  const [visible, setVisible] = useState(() => readConsent() === null);

  useEffect(() => {
    startMetaPixel(); // returning visitors who previously accepted
    const openSettings = () => setVisible(true);
    window.addEventListener('kindstone:meta-consent-settings', openSettings);
    return () => window.removeEventListener('kindstone:meta-consent-settings', openSettings);
  }, []);

  const choose = (accept) => {
    const wasAccepted = readConsent() === 'accepted';
    try {
      window.localStorage.setItem(CONSENT_KEY, accept ? 'accepted' : 'declined');
    } catch {
      // If preferences cannot be stored, do not enable optional tracking.
      return;
    }
    setVisible(false);
    if (accept) startMetaPixel();
    // A reload stops a previously loaded Meta script after consent is withdrawn.
    if (!accept && wasAccepted) window.location.reload();
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Optional website tracking"
      aria-modal="false"
      className="fixed bottom-3 left-3 right-3 z-[100] mx-auto max-w-3xl rounded-2xl border border-navy/15 bg-white p-4 text-charcoal shadow-2xl sm:bottom-5 sm:p-5"
    >
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <p className="flex-1 text-sm leading-relaxed">
          We use optional Meta Pixel tracking to measure website visits and successful
          cleaning quote requests. We do not intentionally send your form responses
          as event parameters. You can decline and still request a quote.
          {' '}<a href="/privacy.html" className="font-semibold underline underline-offset-2">Privacy Policy</a>.
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={() => choose(false)}
            className="rounded-full border border-navy/25 px-4 py-2 text-sm font-semibold text-navy"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={() => choose(true)}
            className="rounded-full bg-electric px-4 py-2 text-sm font-bold text-white"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default MetaPixelConsent;
